/*
  Variant image sync
  When a customer picks another variant (e.g. a color), scroll the product
  gallery to that variant's featured image. The original product-page.js only
  highlights the thumbnail and deliberately never moves the gallery viewport.
  This only scrolls the gallery horizontally, never the page itself.
*/
(function () {
  function initSection(section) {
    var jsonNode = section.querySelector('[data-product-json]');
    var viewport = section.querySelector('[data-gallery-viewport]');
    var gallery = section.querySelector('[data-product-gallery]');
    if (!jsonNode || !viewport) return;

    var product;
    try {
      product = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }
    if (!product || !product.variants) return;

    function getCurrentVariant() {
      var input =
        section.querySelector('[data-variant-id-input]') ||
        section.querySelector('[data-product-form] [name="id"]');
      if (!input) return null;
      var id = Number(input.value);
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === id) return product.variants[i];
      }
      return null;
    }

    var initialVariant = getCurrentVariant();
    var lastMediaId =
      initialVariant && initialVariant.featured_media ? initialVariant.featured_media.id : null;

    function syncGallery() {
      var variant = getCurrentVariant();
      if (!variant || !variant.featured_media) return;

      var mediaId = variant.featured_media.id;
      if (mediaId === lastMediaId) return;
      lastMediaId = mediaId;

      var target = viewport.querySelector('[data-media-id="' + mediaId + '"]');
      if (!target) return;

      var viewportRect = viewport.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var isPeek =
        gallery &&
        gallery.classList.contains('product-gallery--mobile-peek') &&
        window.matchMedia('(max-width: 989px)').matches;
      var offset = isPeek ? (viewport.clientWidth - target.offsetWidth) / 2 : 0;
      var left = targetRect.left - viewportRect.left + viewport.scrollLeft - offset;

      viewport.scrollTo({ left: left, behavior: 'smooth' });
    }

    function scheduleSync() {
      window.setTimeout(syncGallery, 0);
    }

    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-option-button]')) scheduleSync();
    });

    section.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-select]')) scheduleSync();
    });
  }

  function run() {
    document.querySelectorAll('[data-product-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
